module.exports = __webpack_public_path__ + "static/media/vip-message-icon.bd482642.png";